module.exports = __webpack_public_path__ + "img/hero-background.7c89443c.png";